<template>
  <el-dialog title="对账记录" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :append-to-body="true"
             :close-on-click-modal="false"
  >
    <el-col :span="24">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(118)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>

          <el-table-column
            prop="adddate"
            align="left"
            header-align="center"
            width="140"
            label="处理时间">
          </el-table-column>

          <el-table-column
            prop="uname"
            label="操作人员姓名"
            align="center"
            width="100"
            header-align="center">
          </el-table-column>

          <el-table-column
            label="操作人员部门"
            prop="dname"
            width="120"
            align="center"
            header-align="center">
          </el-table-column>

          <el-table-column
            prop="accountdate"
            label="账单年月"
            width="80"
            align="center">
          </el-table-column>

          <el-table-column
            prop="money"
            align="right"
            width="100"
            header-align="center"
            label="对账金额">
            <template slot-scope="scope">
              {{scope.row.money|numeric(2)}}
            </template>
          </el-table-column>

          <el-table-column
            prop="remark"
            align="left"
            header-align="center"
            label="备注"
           >
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 80%;height:24px;"
                   :title="scope.row.remark" @click="ShowLog(scope.row.remark)">{{ scope.row.remark }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot" :style="{textAlign:'center' }">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
    </el-col>
  </el-dialog>
</template>
<script>
  import {getbalanceaccountlog} from '@/api/set/jiesuan';

  export default {
    data() {
      return {
        dialogFormVisible: false,
        tableData: [],
        accountdate: '',
        pcustomerserial: '',
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        }
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      initForm(datevalue, pcustomerserial) {
        this.accountdate = datevalue;
        this.pcustomerserial = pcustomerserial;
        this.bindGrid()
      },
      bindGrid() {
        getbalanceaccountlog({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          pcustomerserial: this.pcustomerserial,
          accountdate: this.accountdate
        }).then((response) => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total
        })
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/SelDateLog.vue